<script setup>
import { ref, computed, onMounted } from 'vue';
import { useAuthStore } from '@/stores/authStore';
import { useOrderStore } from '@/stores/OrderStore';
import { useToast } from 'vue-toastification';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';
import CheckInventoryPopup from '../Inventory/CheckInventoryPopup.vue';

const toast = useToast();
const authStore = useAuthStore();
const orderStore = useOrderStore();

onMounted(() => {
  tippy('#inventoryTooltip', {
    content: 'Check inventory',
    animation: 'scale',
  });
});

</script>

<template>
    <div id="inventoryTooltip" class="cursor-pointer">
      <i
        @click="authStore.toggleCheckInventoryPopup"
        :disabled="!(authStore.isUserLoggedIn || authStore.isManagerLoggedIn)"
        :class="{ 'opacity-50 cursor-not-allowed': !(authStore.isUserLoggedIn || authStore.isManagerLoggedIn) }"
        class="pi pi-warehouse text-center text-purple-500"
        style="font-size: 1.875rem;"
      ></i>
    </div>
    <CheckInventoryPopup v-if="authStore.isCheckInventoryPopupVisible && (authStore.isUserLoggedIn || authStore.isManagerLoggedIn)" />
</template>

<style lang="scss" scoped>

</style>